//@flow
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}; // Vendors


import React from 'react';
import classnames from 'classnames'; // Styles

import './agency-logo.scss'; // Logos

import BoardOfNursingLogo from '../../assets/agency-logos/board-of-nursing.png';
import TDLRLogo from '../../assets/agency-logos/tdlr.png';
import CPALogo from '../../assets/agency-logos/cpa.png';
import TCEQLogo from '../../assets/agency-logos/tceq.png';
import DMVLogo from '../../assets/agency-logos/dmv.png';
import DLRLogo from '../../assets/agency-logos/dlr.png';
import TexasFlagIcon from '../../assets/agency-logos/texas-flag-icon.png';

function Logo(_a) {
  var name = _a.name;

  switch (name) {
    case 'Texas Board of Nursing':
      return React.createElement("img", {
        src: BoardOfNursingLogo,
        alt: name + " logo"
      });

    case 'Texas Department of Licensing and Regulation':
      return React.createElement("img", {
        src: TDLRLogo,
        alt: name + " logo"
      });

    case 'Texas Comptroller of Public Accounts':
      return React.createElement("img", {
        src: CPALogo,
        alt: name + " logo"
      });

    case 'Texas Commission on Environmental Quality':
      return React.createElement("img", {
        src: TCEQLogo,
        alt: name + " logo"
      });

    case 'Texas Department of Motor Vehicles':
      return React.createElement("img", {
        src: DMVLogo,
        alt: name + " logo"
      });

    case 'Texas Department of Public Safety':
      return React.createElement("img", {
        src: DLRLogo,
        alt: name + " logo"
      });

    default:
      return React.createElement("img", {
        src: TexasFlagIcon,
        alt: name + " logo"
      });
  }
}
/**
 * @visibleName Default
 */


function AgencyLogo(_a) {
  var agency = _a.agency,
      className = _a.className,
      props = __rest(_a, ["agency", "className"]);

  if (!agency) return React.createElement(React.Fragment, null);
  var name = agency.name;
  return React.createElement("span", __assign({}, props, {
    className: classnames("agency-logo", className)
  }), React.createElement(Logo, {
    name: name
  }));
}

export default AgencyLogo;